(function () {
  function initAccordionScroll() {
    var container = document.querySelector('.c-pdp__main');
    if (!container) return;

    container.addEventListener('click', function (e) {
      var trigger = e.target.closest('.js-accordion-trigger, .c-pdp-accordion__title');
      if (!trigger) return;

      var accordion = trigger.closest('.c-accordion, .js-accordion, details.c-pdp-accordion');
      if (!accordion) return;

      setTimeout(function () {
        var content = accordion.querySelector('.js-accordion-content, .c-accordion__content, .c-pdp-accordion__content');
        if (!content) return;

        var isOpen =
          accordion.classList.contains('is-active') ||
          accordion.hasAttribute('open') ||
          (content.offsetHeight > 0 && content.style.display !== 'none');

        if (!isOpen) return;

        var offsetTop = 0;
        var el = trigger;
        while (el && el !== container) {
          offsetTop += el.offsetTop;
          el = el.offsetParent;
        }

        var targetScroll = offsetTop - 12;
        var currentScroll = container.scrollTop;
        var distance = targetScroll - currentScroll;

        if (Math.abs(distance) < 10) return;

        var duration = 600;
        var startTime = performance.now();

        function easeInOutQuart(t) {
          return t < 0.5
            ? 8 * t * t * t * t
            : 1 - Math.pow(-2 * t + 2, 4) / 2;
        }

        function step(now) {
          var elapsed = now - startTime;
          var progress = Math.min(elapsed / duration, 1);
          container.scrollTop = currentScroll + distance * easeInOutQuart(progress);
          if (progress < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
      }, 450);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordionScroll);
  } else {
    initAccordionScroll();
  }
})();
